import Flex from '@Components/Bases/Flex';
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined';
import { Button, Dialog, Typography } from '@mui/material';

type ChangeTypeModalProps = {
  topic?: string;
  opened: boolean;
  close: () => void;
  confirm: () => void;
};

const ChangeTypeModal = ({ opened, close, confirm }: ChangeTypeModalProps) => {
  return (
    <Dialog open={opened} onClose={close} maxWidth="xs">
      <Flex p={2} gap={2} borderBottom="1px solid rgba(0, 0, 0, 0.12)">
        <AssignmentLateOutlinedIcon
          style={{ fontSize: 32 }}
          color={'primary'}
        />
        <Flex flexDirection={'column'} gap={1}>
          <Typography fontWeight={800} fontSize={16}>
            ยืนยันการเปลี่ยนตัวเลือก
          </Typography>
          <Typography style={{ whiteSpace: 'pre-line' }}>
            ท่านกำลังเปลี่ยนตัวเลือกซึ่งจะส่งผลให้ข้อมูลที่กรอกไว้ใน {'\n'}{' '}
            ส่วนนี้
            <span style={{ textDecoration: 'underline' }}>ถูกลบออกทั้งหมด</span>
          </Typography>
        </Flex>
      </Flex>
      <Flex gap={2} p={1} justifyContent="flex-end">
        <Button variant="contained" color="inherit" onClick={close}>
          ยกเลิก
        </Button>
        <Button onClick={confirm}>ยืนยัน</Button>
      </Flex>
    </Dialog>
  );
};

export default ChangeTypeModal;
